module.exports = __webpack_public_path__ + "img/larrys_disappearing_scarf_trick.5cb29f82.jpg";